import React from 'react';
import { formatAmount } from './AmountHelper';

interface IProps {
    value: number | string;
    round?: boolean;
}

export type IAmountProps = IProps;

export const Amount = (props: IAmountProps) => {
    return <>{formatAmount(props.value, props.round)}</>;
};
